"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SfilterDistrictType = void 0;
var SfilterDistrictType;
(function (SfilterDistrictType) {
    SfilterDistrictType[SfilterDistrictType["REGION"] = 0] = "REGION";
    SfilterDistrictType[SfilterDistrictType["DISTRICT"] = 1] = "DISTRICT";
})(SfilterDistrictType = exports.SfilterDistrictType || (exports.SfilterDistrictType = {}));
